(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('WaterNetwork', WaterNetwork);

    WaterNetwork.$inject = ['$resource'];

    function WaterNetwork ($resource) {
        var resourceUrl =  'api/water-network/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'queryFilterArea': {
                method: 'GET',
                isArray: true,
                params: {areaFilter:true}
            },
            
            
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
